export default __webpack_public_path__ + "static/images/login/background1.8713518f5382868b0710278d5aa24f3a.png";